import { obterParametrosDaURL } from "../../../../functions";
import { apiAssinaturaDigital } from "../../api";
import { ApiException } from "../../api-exception";
import {
    IResumoOrcamentoRequest
} from "./VerificarSolicitacaoRespondida";

export const NegarContrato = async ({ NumOrc, CodLoja }: IResumoOrcamentoRequest) => {
  const { token } = obterParametrosDaURL();

  try {
    await apiAssinaturaDigital.put(`/Signatario/negarcontrato`, null, {
      params: { NumOrc, CodLoja },
      headers: { token },
    });
  } catch (erro) {
    throw new ApiException(
      erro,
      "Não foi possível negar o contrato de assinatura digital"
    );
  }
};